var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { UserClientContext } from './UserClientContext';
export const useUserClient = () => {
    _react_refresh_temp_1();
    const userClientContextValue = useContext(UserClientContext);
    if (!userClientContextValue) {
        throw new Error('User agent context not available!');
    }
    return userClientContextValue;
};
_react_refresh_temp_1(useUserClient, "TCAj6zryokguTEbdyDiaDTL2bSs=");
